<template>
  <div class="archiveInformes">
    <h1 class="sectionTitle">Informes Anteriores</h1>
    <h2 class="sectionSubtitle">Selecione o informe desejado, em seguida navegue através dos temas.</h2>
    <ul class="archiveInformes--nav">
      <li class="archiveInformes--navItem" :class="{active : currentTab === 0}" @click="currentTab = 0">Informes II</li>
      <li class="archiveInformes--navItem" :class="{active : currentTab === 1}" @click="currentTab = 1">Informes I</li>
    </ul>
    <div class="archiveInformes--content">
      <TabsInformes2 class="archiveInformes--contentItem" v-show='currentTab == 0'/>
      <TabsInformes1 class="archiveInformes--contentItem" v-show='currentTab == 1'/>
    </div>
  </div>
</template>

<script>
import TabsInformes1 from '@/templates/_TabsInformes1'
import TabsInformes2 from '@/templates/_TabsInformes2'

export default {
  name: 'ArchiveInformes',
  components: {
    TabsInformes1,
    TabsInformes2
  },
  data () {
    return {
      currentTab: 0
    }
  }
}
</script>

<style>

</style>
